interface ConfidenceBadgeProps {
  score: number;
  showLabel?: boolean;
}

export function ConfidenceBadge({ score, showLabel = true }: ConfidenceBadgeProps) {
  const pct = Math.round(score * 100);
  const level = score >= 0.8 ? "high" : score >= 0.5 ? "medium" : "low";
  const cls = score >= 0.8 ? "badge-success" : score >= 0.5 ? "badge-warning" : "badge-danger";

  return (
    <span className={`badge ${cls} confidence-${level}`} title={`Confidence: ${pct}%`}>
      <span className="confidence-dot" />
      {showLabel && `${pct}%`}
    </span>
  );
}
